
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 133718","transform":"translate(.485 .485)"}},[_c('circle',{attrs:{"data-name":"Ellipse 6341","cx":"12","cy":"12","r":"12","transform":"translate(-.485 -.485)","fill":"#bac1cc"}}),_c('path',{attrs:{"d":"M15.204 10.453h-2.838a.167.167 0 01-.167-.167V7.448a.835.835 0 10-1.67 0v2.838a.167.167 0 01-.167.167H7.524a.835.835 0 100 1.67h2.838a.167.167 0 01.167.167v2.838a.835.835 0 101.67 0V12.29a.167.167 0 01.167-.167h2.838a.835.835 0 100-1.67zm0 0","fill":"#fff"}})])])
          )
        }
      }
    